export const ALL_ABBVIE_PRO_SYSTEM_SETTINGS = `query($filter:AbbvieProSystemSettingFilter){
    allAbbvieProSystemSettings(filter:$filter){
      nodes{
        id
          formKey
          formText
          category
          country
      }
    }
  }`;

export const ALL_ALLERGAN_PRO_SYSTEM_SETTINGS = `query($filter: AllerganProSystemSettingFilter){
    allAllerganProSystemSettings(filter:$filter){
      nodes{
        id
        formKey
        formText
        category
        country
      }
    }
  }`;

export const CREATE_ABBVIE_PRO_SYSTEM_SETTINGS = `mutation($abbvieProSystemSetting: AbbvieProSystemSettingInput!){
    createAbbvieProSystemSetting(input:{
      abbvieProSystemSetting:$abbvieProSystemSetting
    })
      {
        abbvieProSystemSetting{
          id
        }
      }
  }`;

export const getAbbvieProSystemSettings = `query($country: [String]!,$category: String!){
    getAbbvieProSystemSettings(country:$country,category:$category){
      nodes{
        id
        formKey
        formText
        category
        country
      }
    }
  }`;

export const allAbbvieProFormDataStore = `query($first:Int,$last:Int,$after:Cursor,$before:Cursor,$filter:AbbvieProFormDataStoreFilter){
    allAbbvieProFormDataStores(orderBy:CREATED_AT_DESC,first:$first,last:$last,after:$after,before:$before,filter:$filter){
      nodes{
        id
        formKey
        formData
        createdAt
      }
      totalCount
      pageInfo {
           hasNextPage
           hasPreviousPage
           startCursor
           endCursor
      }
    }
  }`;
export const GET_ABBVIE_PRO_FORM_DATA = `query($formKey: String!,$first:Int,$last:Int,$after:Cursor,$before:Cursor,$filter:AbbvieProFormDataStoreFilter){
    abbvieProSystemSettingByFormKey(formKey:$formKey){
      formKey
      formText
      abbvieProFormDataStoresByFormKey(orderBy:CREATED_AT_DESC,first:$first,last:$last,after:$after,before:$before,filter:$filter){
        nodes{
          id
          formData
          createdAt
          iccId
          eventId
        }
        totalCount
        pageInfo{
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }`;

export const DELETE_FORM_DATA = `mutation($id:UUID!){
    deleteAbbvieProFormDataStoreById(input:{
       id:$id
    })
    {
      abbvieProFormDataStore{
        formKey
      }
    }
  }`;

export const allAllerganProSystemSettings = `query($filter: AllerganProSystemSettingFilter){
    allAllerganProSystemSettings(filter:$filter){
      nodes{
        id
        formKey
        formText
        category
        country
      }
    }
  }`;

export const GET_ALLERGAN_PRO_FORM_DATA = `query($formKey: String!,$first:Int,$last:Int,$after:Cursor,$before:Cursor,$filter:AllerganProFormDataStoreFilter){
    allerganProSystemSettingByFormKey(formKey:$formKey){
      formKey
      formText
      allerganProFormDataStoresByFormKey(orderBy:CREATED_AT_DESC,first:$first,last:$last,after:$after,before:$before,filter:$filter){
        nodes{
          id
          formData
          createdAt
          iccId
          eventId
        }
        totalCount
        pageInfo{
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }`;

export const deleteAllerganProFormDataStoreById = `mutation($id:UUID!){
    deleteAllerganProFormDataStoreById(input:{
      id:$id
    })
    {
      allerganProFormDataStore{
        formKey
      }
    }
  }`;

export const CREATE_ALLERGAN_PRO_SYSTEM_SETTINGS = `mutation($allerganProSystemSetting: AllerganProSystemSettingInput!){
    createAllerganProSystemSetting(input:{
      allerganProSystemSetting: $allerganProSystemSetting
    })
    {
      allerganProSystemSetting{
        id
      }
    }
  }`;

export const CREATE_FORM = `mutation($formSystemSettings: AbbvieProSystemSettingInput!){
    insertAbbvieProSystemSettings(input:{
      formSystemSettings: $formSystemSettings
    }){
      abbvieProSystemSetting{
        id
      }
    }
  }`;
